// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2q6pP{display:-ms-flexbox;display:flex;height:100vh;overflow-x:hidden;width:100%}@media (min-width:1024px){._2q6pP{-ms-flex-direction:row;flex-direction:row}}._2q6pP svg path{vector-effect:non-scaling-stroke}._3IZ1-{-ms-flex:1 0;flex:1 0;height:100%;max-width:100%;overflow-y:auto;padding:1.6rem}@media (min-width:600px){._3IZ1-{padding:6rem}}@media (min-width:1280px){._3IZ1-{padding:8rem 14rem 6rem}}.pageHeader{max-width:600px;max-width:60rem;min-width:360px;min-width:36rem}@media (min-width:600px){.pageHeader{max-width:60rem;min-width:50rem}}@media (min-width:1024px){.pageHeader{max-width:80rem;min-width:50rem}}", ""]);
// Exports
exports.locals = {
	"root": "_2q6pP",
	"content": "_3IZ1-"
};
module.exports = exports;
